import { isCurrentRouteBlocked } from '../../auth/blocked-state-routes';

class App {
 	  [x: string]: any;
 	  static $inject = ['$window','$rootScope', '$state', 'AccountService', 'AlertPaymentService'];
    constructor($window, $rootScope, $state, AccountService, AlertPaymentService) {
        this.isSmart = App.isSmart($window);
        this.rootScope = $rootScope;
        this.$state = $state;
        this.accountService = AccountService;
        this.alertPaymentService = AlertPaymentService;
        this.blurred = false;
    }

    isFullyConfigured: boolean;

    static isSmart($window) {
        let ua = $window['navigator']['userAgent'] || $window['navigator']['vendor'] || $window['opera'];
        return (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/).test(ua);
    }

    $onInit() {
      this.setBluring();

      this.accountService.configChanged
        .subscribe(
          (config: boolean) => {
            this.isFullyConfigured = config;
            this.blurred = this.detectBlurred();
          }
        )

        this.alertPaymentService.onActivatePaymentAlert.subscribe(isPaymentFailed => {
          this.failedPayment = isPaymentFailed;
        });
    }

  setBluring() {
      this.accountService.getAccountConfig().subscribe(
        (conf) => {
          this.isFullyConfigured = conf.data;
          this.blurred = this.detectBlurred();
        }
      );
    }

  private detectBlurred() {
    return !this.isFullyConfigured && (this.isBlockedState());
  }

  private isBlockedState() {
    return isCurrentRouteBlocked();
  }
}

export default {
    controller: App,
    template: require('./app.html')
};
